import styled from 'styled-components';
import Title from 'js/components/core/Modal/Title';

export default styled(Title)`
  padding: 0;
  margin-bottom: 1rem;
`;
